/**
 * Implements a pageview model for use with Google Analytics
 *
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
 */

import Brace from "backbone.brace";
import _ from "underscore";

const Model = Brace.Model.extend({
  namedAttributes: {
    // The title of the page (e.g. homepage)
    // required when object is used
    title: String,
    // URL of the page being tracked.
    // required when `page` is missing
    location: String,
    // The path portion of a URL. This value should start with a slash (/) character.
    // required when `location` is missing
    page: String,
  },

  defaults: {
    title: null,
    location: null,
    page: null,
  },

  validate(attrs) {
    if (_.isEmpty(attrs.title)) {
      return "Required 'title' property is missing from the analytics pageview model.";
    } else if (_.isEmpty(attrs.location) && _.isEmpty(attrs.page)) {
      return "Optional properties, 'location' or 'page' are missing from the analytics pageview model.";
    }
  },
});

export { Model as default };
